import React from "react";
import Professionals from "../Assets/professionals.png";
import "../Styles/About.css";

function About() {
  return (
    <section className="about-section" id="about">
      <div className="about-container">
        
        <div className="about-image-content">
          <div className="about-image-wrapper">
            <img
              src={Professionals}
              alt="Professional Workforce Team"
              className="about-image1"
            />
          </div>
        </div>

        <div className="about-text-content">
          <h3 className="about-title">
            <span>About Us</span>
          </h3>

          <div className="about-points">
            <div className="about-point">
              <p>
                We are Workforce Nexus, a recruitment support company helping
                businesses hire with more confidence, structure, and efficiency.
                We provide tailored talent acquisition support by combining
                industry knowledge with a reliable and disciplined process.
              </p>
            </div>

            <div className="about-point">
              <p>
                Our approach focuses on clarity, consistency, and long-term
                value. We handle recruitment with attention to detail, timely
                communication, and a strong understanding of roles, market
                trends, and expectations.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default About;